import { DatePicker } from "@material-ui/pickers";
import {
  FormDataConsumer,
  ReferenceInput,
  required,
  SelectInput,
  useAuthenticated,
} from "react-admin";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import resourceNames from "../../../common/data/resourceNames";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { VehicleSelectionList } from "../vehicle-mileage-summary/VehicleSelectionList";
import { useAppData } from "../../../common/hooks/useAppData";
import AutocompleteArrayInputWithSelectAll from "../ifta-mileage/AutocompleteArrayInputWithSelectAll";
import { reportFormats } from "../reportUtils";
import { Box, Divider } from "@material-ui/core";

interface Props extends RouteComponentProps {}

export const VehicleMileageReport = (props: Props) => {
  useAuthenticated();
  useSearchFields(undefined, ["name"], resourceNames.ADMIN_VEHICLES);
  const states = useAppData((x) => x.countries[0].states) ?? [];

  return (
    <ReportForm
      reportName="ifta-mileage-detail"
      {...props}
      title="resources.reports.iftaMileage.name"
      submitMethod={(x) => x.reportVehiclemileagereportPost}
    >
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateFrom"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateTo"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <ReferenceInput
        reference={resourceNames.ADMIN_COMPANIES}
        validate={required()}
        source="companyId"
      >
        <SelectInput />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          return (
            formData["companyId"] && (
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  return (
                    formData["companyId"] && (
                      <VehicleSelectionList
                        source="vehicles"
                        filter={{ companyId: formData["companyId"] }}
                      />
                    )
                  );
                }}
              </FormDataConsumer>
            )
          );
        }}
      </FormDataConsumer>
      <Divider style={{ marginTop: "12px", marginBottom: "12px" }} />
      <Box sx={{ mt: "20px", minWidth: "100%" }}>
        <AutocompleteArrayInputWithSelectAll
          source="stateIds"
          label="States"
          choices={states}
          validate={required()}
          variant="outlined"
          style={{ width: "50%" }}
        />
        <SelectInput
          variant="outlined"
          source="reportFormat"
          choices={reportFormats}
          validate={required()}
        />
      </Box>
    </ReportForm>
  );
};
